<template>
  <div class="maintenance-view">

    <crv-fallback-content
        image-name="tools"
        :title="$t('maintenance-page.title')"
        :text="$t('maintenance-page.maintenance')"
    />
    <p class="text-center sub-text">
        {{$t("maintenance-page.sorry")}}
    </p>
  </div>
  <SireFooter />
</template>

<script lang="ts">
import {defineComponent} from "vue"
import SireFooter from '../components/SireFooter.vue'
import { CrvFallbackContent } from '@crv/vue-3-components'

export default defineComponent({
  name: "MaintenanceView",

  components: {
    SireFooter,
    CrvFallbackContent
    }
})
</script>


<style lang="scss" scoped>
.maintenance-view {
  height: 70vh;
  margin-top: 64px; //toolbar-height;
}

.sub-text {
  font-size: 14px;
}
</style>